/* Created by Rowan de Zeeuw on 07/09/2018 */

export function isBoolean(value) {
    return typeof value === 'boolean';
}

export function hasNoValue(value) {
    return value === null || value === undefined;
}
export function hasValue(value) {
    return !hasNoValue(value);
}

export function haveAllValue(...values) {
    return values.every(value => hasValue(value));
}

export function isEmpty(value) {
    // todo: getting ugly, probably a better way, but we'll get back to this.
    return (
        hasNoValue(value) ||
        (!(value instanceof Date) &&
            typeof value !== 'boolean' &&
            typeof value !== 'number' &&
            Object.keys(value).length === 0)
    );
}

export function isLastDigits(value) {
        return value.length === 4 || value.length === 10;
}

export function isNotEmpty(value) {
    return !isEmpty(value);
}

export function isString(str) {
    return typeof str === 'string' || str instanceof String;
}

export function trimRemoveDuplicateWhitespace(value) {
    if (isString(value)) {
        value = value.trim();
        value = value.replace(/[ \t]+/g, ' ');
    }
    return value;
}

export function getBoolean(str) {
    return /^true$/i.test(str);
}

export function nodeListToArray(val) {
    try {
        return Array.prototype.slice.call(val);
    } catch (e) {
        throw new Error('No array-like list');
    }
}

export function isValidDate(d) {
    return d instanceof Date && !isNaN(d);
}

export function isFiniteNumber(value) {
    return typeof value === 'number' && !isNaN(value) && isFinite(value);
}

export function parseCommaToPointInString(value) {
    if (!isString(value)) {
        throw new Error('Not a valid string');
    }

    return value.replace(/,/g, '.');
}
//BEGIN:Coffee Break Methods
export function removeFromStorage() {
    localStorage.removeItem('custPQToken');
    localStorage.removeItem('customerDetails');
    localStorage.removeItem('addressConfig');
    localStorage.removeItem('otpSummary');
    localStorage.removeItem('otpDetails');
    localStorage.removeItem('complianceDetails');
    localStorage.removeItem('httpResponse');
    localStorage.removeItem('notHttpResponse');
    localStorage.removeItem('otpError');
    localStorage.removeItem('confirmationDetails');
}
export function deleteCookie(cname) {
    var d = new Date();
    d.setTime(d.getTime());
    var expires = d.toUTCString();
    return (document.cookie = cname + '=;Path=/;expires=' + expires + ';max-age=0');
}
export function getOtpSummary() {
    var Helpers = window.App.Utils.Helpers;
    let Summary = {
        body: {
            firstName: "",
            middleName: "",
            lastName: "",
            creditLimit: "",
            maritalStatus: "",
            gender: "",
            taxIdentificationNumber: "",
            sssOtherID: "",
            emailAddress: "",
            sourceOfFunds: "",
            employerName: "",
            mobileNumber: "",
            birthDate: "",
            employerBusinessNature: "",
            withEcard: "",
            referenceNumber: "",
            selectedCards: [],
            selectedAddress: [],
            submitApiPayLoad: {
                primaryCreditCard: "",
                secondaryCreditCard: "",
                primaryCreditCardName: "",
                secondaryCreditCardName: "",
                virtualCreditCard: false,
                billingAddressType: "",
                emailAddress: "",
                maritalStatus: "",
                lastName: "",
                middleName: "",
                sourceOfFunds: "",
                employerName: "",
                employerBusinessNature: "",
                employmentCode: "",
                taxIdentificationNumber: "",
                sssOtherID: "",
                termsAndCondition: false
            }

        }
    };
    if (!localStorage.getItem("otpSummary")) {
        var setToStorage = Helpers.setItemToStorage("otpSummary", JSON.stringify(Summary));
    }
    return JSON.parse(Helpers.getItemFromStorage("otpSummary"));
}
export function saveOtpSummary(fromStorage) {
    var Helpers = window.App.Utils.Helpers;
    Helpers.setItemToStorage("otpSummary", JSON.stringify(fromStorage));
    var itemFromStorage = Helpers.getItemFromStorage("otpSummary");
    return itemFromStorage;
}
export function submitApi(url, reqHeaders, data) {
    return fetch(`${url}`, {
        credentials: "include",
        method: 'POST',
        headers: reqHeaders,
        body: JSON.stringify(data)
    }).then(r => r.json(), (err) => {
        console.error("Error calling web service ", err);
    });
}
export function apiCall(url, httpMethod, callHeaders) {
    return fetch(`${url}`, {
        credentials: "include",
        method: httpMethod,
        headers: callHeaders
    }).then(r => r.json(), (err) => {
        console.error("Error calling web service ", err);
    });
}

export function getJourneyCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
export function logObj(obj) {
    if (window.App.Utils.Helpers.isLocalhost()) {
        console.log(obj);
    }
}
export function logAttrObj(str, obj) {
    if (window.App.Utils.Helpers.isLocalhost()) {
        console.log(str, obj);
    }
}
//Begin: Json Mapping
export function transformMapData(dataSource, mapping) {
    let localDS = {}
    for (let key in mapping) {
        let mapto = mapping[key].mapto;
        let valueFromSource = eval('dataSource.' + mapto);
        if (mapping[key].condition !== undefined) {
            let conditionKey = mapping[key].condition.key;
            let conditionValue = mapping[key].condition.value;
            if (Array.isArray(valueFromSource)) {
                valueFromSource.forEach(function (item, index) {
                    if (item[conditionKey] === conditionValue) {
                        localDS[key] = eval('dataSource.' + mapto + '[' + index + ']');
                    }
                })
            }
        } else {
            localDS[key] = eval('dataSource.' + mapto);
        }
    }
    return localDS;
}
//End: Json Mapping
// END: Coffeebreak Methods
//BEGIN: AMTC Methods
let digitalApplicationFormValues = {};
export function setDigitalApplicationFormValues(data) {
    console.log(data);
    digitalApplicationFormValues = data;

}
export function getDigitalApplicationFormValues(data) {
    console.log(digitalApplicationFormValues);
    return digitalApplicationFormValues;
}
//END: AMTC Methods


// WEBPACK FOOTER //
// ./collection-institutional-portal/src/modules/app-global/scripts/utils/object/object.js